import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VModal from 'vue-js-modal'
import PortalVue from 'portal-vue'
import VTooltip from "v-tooltip";
import '@/assets/tooltips.css/'
import '@/assets/styles.css';
import VueChatScroll from "vue-chat-scroll/dist/vue-chat-scroll";
import {Filters} from "./wl-core/api/classes/Filters";
import './registerServiceWorker'
import WlUnitText from "@/wl-unit-text";

Vue.config.productionTip = false;
Vue.use(PortalVue);
Vue.use(VModal, {dynamic: true, dynamicDefaults: {}});
Vue.use(VTooltip);
Vue.use(VueChatScroll);
Vue.use(WlUnitText);
Vue.filter('time', Filters.time);
Vue.filter('date', Filters.date);
Vue.filter('year', Filters.year);
Vue.filter('fullDate', Filters.fullDate);
Vue.filter('fixed', Filters.fixed);
Vue.filter('emptyString', Filters.emptyString)
Vue.filter('month', Filters.month)
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');

store.commit('setSubDomain');
/** let domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
 api.publicEndpoints.getRedirectLink(getUrlVars(window.location.href)['token']).then((link) => {
    if (domain !== /:\/\/([^\/]+)/.exec(link)[1] && !getUrlVars(link)['dont'])
    {
        store.commit('showLoading');
        store.commit('setLoadingMessage', 'Ανακατεύθυνση...');
        window.location.replace(link);
    }
}).finally(() => {

})
 **/
